import { useEffect, useState } from "react";

const navLinks = [
  { label: "正在发生", href: "#home" },
  { label: "实时热榜", href: "#toplist" },
  { label: "深度专题", href: "#feature" },
  { label: "热门频道", href: "#channels" },
  { label: "帮助答疑", href: "#faq" },
  { label: "关于我们", href: "#about" },
];

const tickerNews = [
  "《云起长歌》今晚收官，大结局三分钟冲上榜首",
  "城市巡回音乐节首站门票三分钟售罄",
  "AI 影像旗舰官宣下月发布，端侧创作成新卖点",
  "助农直播单场带火县域脐橙 40 万斤",
  "老牌男团官宣「毕业巡演」，青春回忆刷屏",
  "多巴胺早餐走红，用色彩治愈你的通勤早晨",
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const logoBlock = (
    <a href="#home" className="flex items-center gap-2.5 group" aria-label="吃瓜在线 首页">
      <span className="relative flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50 shadow-sm">
        <i className="ri-focus-2-line text-lg" />
      </span>
      <span className="flex flex-col leading-none">
        <span className="font-heading text-xl font-bold tracking-tight text-foreground-900">吃瓜在线</span>
        <span className="text-[10px] font-medium tracking-[0.28em] text-foreground-500">热点 · 一手 · 持续更新</span>
      </span>
    </a>
  );

  return (
    <>
      <header
        className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
          scrolled
            ? "border-b border-background-200/70 bg-background-50/90 shadow-[0_1px_0_0_rgba(0,0,0,0.02)] backdrop-blur-md"
            : "border-b border-transparent bg-background-50/60 backdrop-blur-sm"
        }`}
      >
        <div className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between px-4 md:px-6">
          {logoBlock}

          {/* desktop nav */}
          <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-primary-50 hover:text-primary-700"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="hidden items-center gap-3 lg:flex">
            <a
              href="#subscribe"
              className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-add-line text-base" />
              我要投稿
            </a>
            <button
              type="button"
              className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 bg-background-50 text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-700"
              aria-label="实时状态"
              title="已接入实时热点数据源"
            >
              <i className="ri-signal-wifi-line" />
            </button>
          </div>

          {/* mobile toggle */}
          <button
            type="button"
            className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 lg:hidden"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? "关闭菜单" : "打开菜单"}
            aria-expanded={open}
          >
            <i className={`text-2xl ${open ? "ri-close-line" : "ri-menu-3-line"}`} />
          </button>
        </div>

        {/* mobile menu */}
        <div
          className={`overflow-hidden border-b border-background-200/70 bg-background-50 transition-all duration-300 lg:hidden ${
            open ? "max-h-[420px]" : "max-h-0 border-transparent"
          }`}
        >
          <nav className="flex flex-col gap-1 px-4 py-3" aria-label="移动端导航">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground-700 hover:bg-primary-50 hover:text-primary-700"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#subscribe"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50"
            >
              <i className="ri-add-line text-base" />
              我要投稿
            </a>
          </nav>
        </div>
      </header>

      {/* breaking ticker */}
      <div className="fixed inset-x-0 top-16 z-40 hidden items-center border-b border-background-200/70 bg-accent-600 lg:flex">
        <div className="mx-auto flex w-full max-w-7xl items-center px-4 md:px-6">
          <div className="flex shrink-0 items-center gap-2 py-1.5 pr-4 text-background-50">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-background-50 opacity-75" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-background-50" />
            </span>
            <span className="text-xs font-bold tracking-widest">最新进展</span>
          </div>
          <div className="relative flex-1 overflow-hidden py-1.5">
            <div className="ticker-track text-xs text-background-50">
              {[...tickerNews, ...tickerNews].map((n, i) => (
                <span key={i} className="flex items-center gap-6 pr-6">
                  <span className="font-medium">{n}</span>
                  <i className="ri-arrow-right-line text-background-50/60" />
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}